// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upcoming-fights {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  animation: fadeIn 0.2s ease-in;
}

/* ── Prop column separator ───────────────────────────────────── */
.th-prop-sep,
.td-prop-sep {
  border-left: 1px solid #1e293b;
}

/* ── Victory bet column ──────────────────────────────────────── */
.td-vbet {
  text-align: right;
  vertical-align: middle;
}

/* ── Method bet suggestion (analysis panel) ──────────────────── */
.ap-method-title {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--text-muted, #6b7280);
  margin-bottom: 0.75rem;
}
.ap-method-bet {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  flex-wrap: wrap;
  font-weight: 400;
  text-transform: none;
  letter-spacing: 0;
  padding: 0.18rem 0.45rem;
  background: rgba(16, 185, 129, 0.08);
  border: 1px solid rgba(16, 185, 129, 0.25);
  border-radius: 4px;
}
.amb-label { color: #10b981; font-weight: 600; font-size: 0.65rem; }
.amb-line  { color: #e2e8f0; font-weight: 600; font-size: 0.72rem; }
.amb-odds  { color: #94a3b8; font-size: 0.7rem; }
.amb-bk    { color: #64748b; font-size: 0.65rem; }
.amb-edge  { color: #10b981; font-weight: 700; font-size: 0.7rem; }
.amb-kelly { color: #f59e0b; font-weight: 700; font-size: 0.7rem; }

/* ── Model warning banner ─────────────────────────────────────── */

.model-warning-banner {
  display: flex;
  align-items: flex-start;
  gap: 0.6rem;
  background: rgba(239, 68, 68, 0.08);
  border: 1px solid rgba(239, 68, 68, 0.3);
  border-radius: 8px;
  padding: 0.65rem 1rem;
  font-size: 0.8rem;
  color: #fca5a5;
  line-height: 1.5;
}
.mwb-icon {
  font-size: 0.9rem;
  flex-shrink: 0;
  margin-top: 1px;
}
.mwb-text { color: #fca5a5; }
.mwb-text strong { color: #ef4444; }
.mwb-fight { white-space: nowrap; }
.mwb-fight em { font-style: normal; color: #94a3b8; font-size: 0.75rem; }

/* ── Filter bar ──────────────────────────────────────────────── */

.uf-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
}

.uf-bar-left {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.uf-back {
  color: #64748b;
  text-decoration: none;
  font-size: 0.825rem;
  font-weight: 500;
  transition: color 0.15s;
}
.uf-back:hover { color: #f59e0b; }

.uf-count {
  font-size: 0.825rem;
  color: #64748b;
}

.uf-count-val {
  font-size: 0.75rem;
  font-weight: 600;
  color: #10b981;
  background: rgba(16, 185, 129, 0.1);
  padding: 0.15rem 0.5rem;
  border-radius: 4px;
}

.uf-bar-right {
  display: flex;
  align-items: center;
  gap: 0.6rem;
}

.uf-toggle {
  display: flex;
  background: #1e293b;
  border: 1px solid #334155;
  border-radius: 6px;
  overflow: hidden;
}

.uf-tog {
  padding: 0.35rem 0.85rem;
  font-size: 0.78rem;
  font-weight: 600;
  background: transparent;
  border: none;
  color: #64748b;
  cursor: pointer;
  transition: all 0.15s;
}
.uf-tog:hover { color: #cbd5e1; }
.uf-tog-on { background: #334155; color: #f1f5f9; }

.uf-wc {
  padding: 0.35rem 0.65rem;
  background: #1e293b;
  border: 1px solid #334155;
  border-radius: 6px;
  color: #cbd5e1;
  font-size: 0.78rem;
  cursor: pointer;
  outline: none;
}

.uf-refresh {
  width: 30px;
  height: 30px;
  background: #1e293b;
  border: 1px solid #334155;
  border-radius: 6px;
  color: #64748b;
  font-size: 0.95rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;
}
.uf-refresh:hover { color: #f59e0b; }

/* ── Single event hero ───────────────────────────────────────── */

.uf-event-hero {
  background: linear-gradient(135deg, #1e293b 0%, #1a2a3a 100%);
  border: 1px solid #334155;
  border-left: 4px solid #f59e0b;
  border-radius: 10px;
  padding: 1rem 1.5rem;
}
.ueh-name { font-size: 1.25rem; font-weight: 700; color: #f1f5f9; }
.ueh-meta { font-size: 0.825rem; color: #94a3b8; margin-top: 0.2rem; }

/* ── Empty state ─────────────────────────────────────────────── */

.uf-empty {
  text-align: center;
  padding: 3rem;
  color: #475569;
  font-size: 0.875rem;
  background: #1e293b;
  border: 1px dashed #334155;
  border-radius: 10px;
}

/* ── Table container ─────────────────────────────────────────── */

.fights-wrap {
  background: #1e293b;
  border: 1px solid #334155;
  border-radius: 12px;
  overflow: hidden;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.fights-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.84rem;
}

/* ── Header row ──────────────────────────────────────────────── */

.fights-table thead tr {
  background: #0f172a;
  border-bottom: 1px solid #334155;
}

.fights-table th {
  padding: 0.55rem 0.75rem;
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: #475569;
  white-space: nowrap;
}

.th-left  { text-align: left; }
.th-right { text-align: right; }

/* ── Event group header row ──────────────────────────────────── */

.tr-group td {
  padding: 0.5rem 0.75rem;
  background: #0f172a;
  border-top: 1px solid #334155;
  border-bottom: 1px solid #1e293b;
}

.eg-name {
  font-size: 0.8rem;
  font-weight: 700;
  color: #cbd5e1;
  margin-right: 0.6rem;
}

.eg-meta {
  font-size: 0.75rem;
  color: #475569;
  margin-right: 0.6rem;
}

.eg-count {
  font-size: 0.7rem;
  color: #334155;
}

/* ── Card section header row (Main Card / Prelims) ───────────── */

.tr-section td {
  padding: 0.3rem 0.75rem;
  background: #1e293b;
  border-top: 1px solid #334155;
  border-bottom: 1px solid #334155;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #64748b;
}

/* ── Fight rows ──────────────────────────────────────────────── */

/* Top of each fight pair — creates visual gap between fights */
.tr-a td {
  border-top: 2px solid #0f172a;
}
.tr-a:first-child td,
.tr-group + .tr-a td,
.tr-section + .tr-a td {
  border-top: none;
}

/* Bottom of a fight pair (no analysis below) */
.tr-last td {
  border-bottom: 1px solid #1e293b;
}

/* No bottom border between A and B of same fight */
.tr-b td { border-bottom: none; }

/* Value-bet row: subtle green highlight */
.tr-bet {
  background: rgba(16, 185, 129, 0.04);
}

.fights-table tbody tr:hover td {
  background: rgba(255, 255, 255, 0.02);
}

/* ── Cell styles ─────────────────────────────────────────────── */

.fights-table td {
  padding: 0.45rem 0.75rem;
  vertical-align: middle;
}

/* Context column (rowspan=2) */
.td-ctx {
  background: rgba(0, 0, 0, 0.18);
  vertical-align: middle;
  border-right: 1px solid #0f172a;
}

.ctx-wc {
  font-size: 0.72rem;
  font-weight: 600;
  color: #94a3b8;
  line-height: 1.3;
}

.ctx-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
  margin-top: 0.2rem;
}

.ctx-tag {
  font-size: 0.6rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  padding: 0.1rem 0.35rem;
  border-radius: 2px;
}
.ctx-main  { background: rgba(59, 130, 246, 0.2); color: #93c5fd; }
.ctx-title { background: rgba(245, 158, 11, 0.2); color: #fbbf24; }
.ctx-model-warn { background: rgba(239, 68, 68, 0.15); color: #fca5a5; cursor: help; }
.ctx-reliability { cursor: help; }
.ctx-reliability.rel-high   { background: rgba(52, 211, 153, 0.15); color: #34d399; }
.ctx-reliability.rel-medium { background: rgba(251, 191, 36, 0.15); color: #fbbf24; }
.ctx-reliability.rel-low    { background: rgba(248, 113, 113, 0.15); color: #f87171; }

/* Dim edge/Kelly values for low-reliability predictions */
.tr-low-rel .td-edge,
.tr-low-rel .td-kelly,
.tr-low-rel .kelly-chip { opacity: 0.45; }

/* Reliability warning in analysis panel */
.ap-reliability-warn {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  background: rgba(248, 113, 113, 0.08);
  border: 1px solid rgba(248, 113, 113, 0.2);
  border-radius: 6px;
  padding: 0.6rem 0.8rem;
  margin-bottom: 0.75rem;
}
.ap-rel-icon {
  flex-shrink: 0;
  width: 1.2rem;
  height: 1.2rem;
  line-height: 1.2rem;
  text-align: center;
  font-size: 0.7rem;
  font-weight: 800;
  background: rgba(248, 113, 113, 0.25);
  color: #f87171;
  border-radius: 50%;
}
.ap-rel-title {
  font-size: 0.72rem;
  font-weight: 700;
  color: #f87171;
  margin-bottom: 0.15rem;
}
.ap-rel-reason {
  font-size: 0.68rem;
  color: #94a3b8;
  line-height: 1.3;
}

.ctx-age {
  font-size: 0.63rem;
  color: #334155;
  margin-top: 0.3rem;
}

/* Fighter name column */
.td-fighter {
  min-width: 130px;
}

/* Numeric columns — right-aligned */
.td-num {
  text-align: right;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  color: #cbd5e1;
}

.td-muted { color: #64748b; }

/* Odds column */
.td-odds {
  text-align: right;
  white-space: nowrap;
}

.odds-val {
  font-weight: 700;
  color: #e2e8f0;
  font-family: 'Courier New', monospace;
  font-size: 0.88rem;
}

.odds-bk {
  display: block;
  font-size: 0.65rem;
  color: #475569;
  margin-top: 0.1rem;
}

/* Edge column */
.td-edge { font-weight: 600; }
.edge-pos { color: #10b981; }
.edge-neg { color: #475569; }

/* Kelly column */
.td-kelly { text-align: right; }

.kelly-chip {
  display: inline-block;
  background: rgba(16, 185, 129, 0.15);
  color: #10b981;
  border: 1px solid rgba(16, 185, 129, 0.3);
  padding: 0.2rem 0.55rem;
  border-radius: 4px;
  font-size: 0.78rem;
  font-weight: 700;
  white-space: nowrap;
}

.td-dash {
  color: #334155;
}

/* ── Past-event result chips ─────────────────────────────────── */

.fighter-cell {
  display: flex;
  align-items: center;
  gap: 0.4rem;
}

.ctx-method {
  font-size: 0.7rem;
  color: #64748b;
  margin-top: 0.2rem;
}

.result-chip {
  display: inline-block;
  padding: 0.15rem 0.45rem;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.02em;
}
.result-w { background: rgba(16, 185, 129, 0.15); color: #10b981; }
.result-l { background: rgba(239, 68, 68, 0.12); color: #ef4444; }
.result-d { background: rgba(100, 116, 139, 0.12); color: #94a3b8; }

.td-method {
  text-align: right;
  font-size: 0.78rem;
  color: #94a3b8;
  white-space: nowrap;
  vertical-align: middle;
}

/* Add odds button */
.add-odds-btn {
  background: transparent;
  border: 1px dashed #334155;
  border-radius: 3px;
  color: #475569;
  font-size: 0.72rem;
  padding: 0.2rem 0.45rem;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.15s;
  float: right;
}
.add-odds-btn:hover { border-color: #f59e0b; color: #f59e0b; }

/* Actions column (rowspan=2) */
.td-act {
  vertical-align: middle;
  text-align: center;
  border-left: 1px solid #0f172a;
  background: rgba(0, 0, 0, 0.1);
}

.act-expand {
  display: block;
  width: 100%;
  background: none;
  border: 1px solid #334155;
  border-radius: 4px;
  color: #64748b;
  font-size: 0.7rem;
  padding: 0.2rem;
  cursor: pointer;
  margin-bottom: 0.35rem;
  transition: all 0.15s;
}
.act-expand:hover,
.act-open { border-color: #f59e0b; color: #f59e0b; }

.act-log {
  display: block;
  width: 100%;
  background: #10b981;
  color: #0f172a;
  border: none;
  border-radius: 4px;
  font-size: 0.72rem;
  font-weight: 700;
  padding: 0.2rem;
  cursor: pointer;
  transition: background 0.15s;
}
.act-log:hover { background: #34d399; }

/* ── Analysis row ────────────────────────────────────────────── */

.tr-analysis td {
  padding: 0;
  border-bottom: 1px solid #334155;
}

.analysis-panel {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem 1.25rem;
  background: #0f172a;
}

.ap-reasoning {
  padding: 0.875rem 1rem;
  background: #1e293b;
  border-left: 3px solid #f59e0b;
  border-radius: 4px;
  font-size: 0.82rem;
  color: #cbd5e1;
  line-height: 1.65;
}

.ap-reasoning strong { color: #f59e0b; }

.r-line   { margin: 0.25rem 0; }
.r-bullet { padding-left: 0.75rem; margin: 0.15rem 0; }

.ap-no-reason {
  color: #475569;
  font-size: 0.82rem;
  font-style: italic;
  margin: 0;
}

.ap-compare {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.apc-col {
  background: #1e293b;
  border: 1px solid #334155;
  border-radius: 8px;
  padding: 0.75rem;
}

.apc-name {
  font-size: 0.875rem;
  font-weight: 700;
  color: #f1f5f9;
  padding-bottom: 0.45rem;
  margin-bottom: 0.45rem;
  border-bottom: 1px solid #334155;
}

.apc-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.78rem;
  padding: 0.2rem 0;
  color: #64748b;
}
.apc-row b    { color: #e2e8f0; font-weight: 600; }
.apc-pos      { color: #10b981 !important; }
.apc-neg      { color: #475569 !important; }
.apc-kelly    { color: #f59e0b !important; }

/* ── Method of Victory bars ───────────────────────────────────── */

.ap-method, .ap-glicko2 {
  margin-top: 0.75rem;
  padding-top: 0.75rem;
  border-top: 1px solid #1e293b;
}

.ap-method-title {
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #64748b;
  margin-bottom: 0.5rem;
}

.ap-method-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.apm-col {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.apm-bar-row {
  display: flex;
  align-items: center;
  gap: 0.4rem;
}

.apm-label {
  font-size: 0.7rem;
  color: #94a3b8;
  width: 5.5rem;
  flex-shrink: 0;
}

.apm-bar {
  flex: 1 1;
  height: 8px;
  background: #1e293b;
  border-radius: 4px;
  overflow: hidden;
}

.apm-fill {
  height: 100%;
  border-radius: 4px;
  transition: width 0.3s ease;
}

.apm-ko  { background: #ef4444; }
.apm-sub { background: #3b82f6; }
.apm-dec { background: #6b7280; }

.apm-pct {
  font-size: 0.75rem;
  color: #e2e8f0;
  width: 2.5rem;
  text-align: right;
  flex-shrink: 0;
}

.apm-no-data {
  font-size: 0.75rem;
  color: #475569;
  font-style: italic;
}

/* ── FighterName tooltip ─────────────────────────────────────── */

.fn-wrap {
  position: relative;
  display: inline-block;
}

.fn-name {
  font-size: 0.875rem;
  font-weight: 600;
  color: #e2e8f0;
  cursor: default;
  border-bottom: 1px dotted #334155;
  white-space: nowrap;
}

.fn-tip {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  z-index: 200;
  background: #0f172a;
  border: 1px solid #334155;
  border-radius: 8px;
  padding: 0.7rem;
  min-width: 185px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.6);
  white-space: nowrap;
  pointer-events: none;
}

.fnt-head {
  font-size: 0.825rem;
  font-weight: 700;
  color: #f1f5f9;
  border-bottom: 1px solid #1e293b;
  padding-bottom: 0.3rem;
  margin-bottom: 0.35rem;
}

.fnt-record {
  font-size: 0.8rem;
  font-weight: 700;
  color: #f59e0b;
  margin-bottom: 0.35rem;
}

.fnt-row {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  font-size: 0.75rem;
  color: #64748b;
  padding: 0.08rem 0;
}
.fnt-row b { color: #e2e8f0; }

.fnt-fights {
  margin-top: 0.4rem;
  border-top: 1px solid #1e293b;
  padding-top: 0.35rem;
}
.fnt-fights-label {
  font-size: 0.65rem;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #334155;
  margin-bottom: 0.2rem;
}
.fnt-fight { font-size: 0.75rem; color: #64748b; padding: 0.06rem 0; }
.fnt-win   { color: #10b981; }
.fnt-loss  { color: #ef4444; }
.fnt-draw  { color: #f59e0b; }

/* ── Modal ───────────────────────────────────────────────────── */

.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-box {
  background: #1e293b;
  border: 1px solid #334155;
  border-radius: 12px;
  width: 360px;
  max-width: 95vw;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.5);
}

.modal-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.875rem 1.25rem;
  border-bottom: 1px solid #334155;
  font-weight: 700;
  color: #f1f5f9;
  font-size: 0.9rem;
}

.modal-close {
  background: none;
  border: none;
  color: #64748b;
  font-size: 1.3rem;
  cursor: pointer;
  padding: 0;
  line-height: 1;
}
.modal-close:hover { color: #f1f5f9; }

.modal-body {
  padding: 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 0.875rem;
}

.modal-bet-summary {
  display: flex;
  align-items: baseline;
  gap: 0.75rem;
  padding: 0.65rem 0.875rem;
  background: #0f172a;
  border-radius: 6px;
}

.mbs-fighter { font-weight: 700; color: #f1f5f9; font-size: 0.95rem; }
.mbs-odds { font-weight: 700; color: #f59e0b; font-family: 'Courier New', monospace; }

.form-group { display: flex; flex-direction: column; gap: 0.3rem; }
.form-group label { font-size: 0.75rem; color: #64748b; }
.form-group select,
.form-group input {
  padding: 0.5rem 0.65rem;
  background: #0f172a;
  border: 1px solid #334155;
  border-radius: 6px;
  color: #f1f5f9;
  font-size: 0.875rem;
  outline: none;
}
.form-group select:focus,
.form-group input:focus { border-color: #f59e0b; }

.modal-foot {
  display: flex;
  justify-content: flex-end;
  gap: 0.65rem;
  padding: 0.875rem 1.25rem;
  border-top: 1px solid #334155;
}

/* ── Line Movement ───────────────────────────────────────────── */

.ap-line-movement {
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #1e293b;
}

/* direction label */
.lm-direction {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.82rem;
  font-weight: 600;
  padding: 0.15rem 0.5rem;
  border-radius: 4px;
  margin-bottom: 0.35rem;
}

.lm-shortened {
  color: #4ade80;
  background: rgba(74, 222, 128, 0.1);
}

.lm-drifted {
  color: #fb923c;
  background: rgba(251, 146, 60, 0.1);
}

.lm-stable {
  color: #94a3b8;
  background: rgba(148, 163, 184, 0.08);
}

.lm-pct {
  font-size: 0.75rem;
  font-weight: 400;
  opacity: 0.8;
}

/* opening → current odds row */
.lm-odds-flow {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-family: 'Courier New', monospace;
  font-size: 0.82rem;
  margin-bottom: 0.2rem;
}

.lm-open  { color: #64748b; }
.lm-arr   { color: #475569; font-size: 0.7rem; }
.lm-curr  { color: #e2e8f0; font-weight: 600; }

/* snapshot metadata */
.lm-info {
  font-size: 0.72rem;
  color: #475569;
  font-style: italic;
}

.lm-tracking {
  font-size: 0.78rem;
  color: #475569;
  font-style: italic;
}

/* ── Row edge accent borders ─────────────────────────────────── */

.tr-a.row-edge-gold td:first-child { border-left: 3px solid #f59e0b; }
.tr-a.row-edge-green td:first-child { border-left: 3px solid #10b981; }
.tr-a.row-edge-blue  td:first-child { border-left: 3px solid #3b82f6; }

/* ── Signal labels in edge column ───────────────────────────── */

.edge-signal {
  display: block;
  font-size: 0.6rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  margin-bottom: 2px;
  line-height: 1;
}
.sig-gold  { color: #f59e0b; }
.sig-green { color: #10b981; }
.sig-blue  { color: #3b82f6; }

/* ── Fighter name font ───────────────────────────────────────── */

.fighter-cell,
.fn-name {
  font-family: 'Barlow Condensed', 'Arial Narrow', sans-serif;
  font-weight: 700;
  font-size: 0.97rem;
  letter-spacing: 0.02em;
}

/* ── Analysis panel: Bet hero ────────────────────────────────── */

.ap-bet-hero {
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid #334155;
  border-radius: 6px;
  padding: 0.75rem 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.ap-bet-hero-pick {
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #64748b;
}

.ap-bet-hero-name {
  font-family: 'Barlow Condensed', sans-serif;
  font-size: 1.1rem;
  font-weight: 700;
  color: #f1f5f9;
}

.ap-hero-signal {
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.06em;
}

.ap-bet-hero-detail {
  font-size: 0.8rem;
  color: #94a3b8;
}

/* ── Analysis panel: Extra context toggle ────────────────────── */

.ap-extra-toggle {
  background: none;
  border: 1px solid #334155;
  border-radius: 4px;
  color: #64748b;
  font-size: 0.75rem;
  cursor: pointer;
  padding: 0.3rem 0.75rem;
  transition: border-color 0.15s, color 0.15s;
  align-self: flex-start;
}
.ap-extra-toggle:hover { border-color: #475569; color: #94a3b8; }

/* ── Tablet ──────────────────────────────────────────────────── */

@media (max-width: 900px) {
  .ap-compare { grid-template-columns: 1fr; }
  .ap-method-grid { grid-template-columns: 1fr; }
}

/* ── Mobile ──────────────────────────────────────────────────── */

@media (max-width: 600px) {
  /* Filter bar: compact horizontal */
  .uf-bar { flex-direction: column; align-items: stretch; gap: 0.4rem; }
  .uf-bar-right { flex-wrap: wrap; gap: 0.4rem; }
  .uf-tog { padding: 0.3rem 0.55rem; font-size: 0.72rem; }
  .uf-wc { padding: 0.3rem 0.45rem; font-size: 0.72rem; max-width: 120px; }
  .uf-refresh { width: 28px; height: 28px; font-size: 0.85rem; }
  .uf-count { font-size: 0.75rem; }

  /* Table: fixed layout, percentages sum to 100% */
  .fights-table { min-width: unset; font-size: 0.76rem; table-layout: fixed; width: 100%; }
  .fights-table td { padding: 0.35rem 0.4rem; }
  .fights-table th { padding: 0.4rem 0.35rem; font-size: 0.6rem; }

  /* Context column */
  .td-ctx { padding: 0.1rem 0.05rem; text-align: center; border-right: none; overflow: hidden; }
  .ctx-tag { font-size: 0.5rem; padding: 0.02rem 0.08rem; }
  .ctx-badges { gap: 0; margin-top: 0; justify-content: center; }

  /* Fighter name: truncate within fixed column */
  .td-fighter { min-width: unset; overflow: hidden; }
  .fn-name {
    font-size: 0.72rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
    display: inline-block;
  }
  .fighter-cell { overflow: hidden; }
  .fn-tip { display: none; }

  /* Odds: hide bookmaker, compact */
  .odds-bk { display: none; }
  .odds-val { font-size: 0.72rem; }

  /* Kelly: compact */
  .kelly-chip { padding: 0.1rem 0.25rem; font-size: 0.65rem; }

  /* Edge signals: hidden on mobile */
  .edge-signal { display: none; }

  /* Actions: tighter */
  .td-act { padding: 0.25rem 0.3rem; }
  .act-expand, .act-log { font-size: 0.65rem; padding: 0.15rem; }

  /* Event headers: compact */
  .eg-name { font-size: 0.72rem; }
  .eg-meta { font-size: 0.68rem; }
  .eg-count { display: none; }

  /* Analysis panel */
  .analysis-panel { padding: 0.75rem; gap: 0.75rem; }
  .ap-bet-hero { padding: 0.55rem 0.75rem; }
  .ap-bet-hero-name { font-size: 0.95rem; }
  .ap-reasoning { font-size: 0.76rem; padding: 0.65rem 0.75rem; }

  /* Warning banner */
  .model-warning-banner { font-size: 0.72rem; padding: 0.5rem 0.75rem; }

  /* Event hero */
  .ueh-name { font-size: 1.05rem; }
  .ueh-meta { font-size: 0.75rem; }
  .uf-event-hero { padding: 0.75rem 1rem; }
}
`, "",{"version":3,"sources":["webpack://./src/components/UpcomingFights.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,8BAA8B;AAChC;;AAEA,mEAAmE;AACnE;;EAEE,8BAA8B;AAChC;;AAEA,mEAAmE;AACnE;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,iCAAiC;EACjC,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,wBAAwB;EACxB,oCAAoC;EACpC,0CAA0C;EAC1C,kBAAkB;AACpB;AACA,aAAa,cAAc,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;AACnE,aAAa,cAAc,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;AACnE,aAAa,cAAc,EAAE,iBAAiB,EAAE;AAChD,aAAa,cAAc,EAAE,kBAAkB,EAAE;AACjD,aAAa,cAAc,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;AAClE,aAAa,cAAc,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;;AAElE,oEAAoE;;AAEpE;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,mCAAmC;EACnC,wCAAwC;EACxC,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;AACA,YAAY,cAAc,EAAE;AAC5B,mBAAmB,cAAc,EAAE;AACnC,aAAa,mBAAmB,EAAE;AAClC,gBAAgB,kBAAkB,EAAE,cAAc,EAAE,kBAAkB,EAAE;;AAExE,mEAAmE;;AAEnE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA,iBAAiB,cAAc,EAAE;;AAEjC;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mCAAmC;EACnC,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;AACA,gBAAgB,cAAc,EAAE;AAChC,aAAa,mBAAmB,EAAE,cAAc,EAAE;;AAElD;EACE,wBAAwB;EACxB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB;AACA,oBAAoB,cAAc,EAAE;;AAEpC,mEAAmE;;AAEnE;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;AACtB;AACA,YAAY,kBAAkB,EAAE,gBAAgB,EAAE,cAAc,EAAE;AAClE,YAAY,mBAAmB,EAAE,cAAc,EAAE,kBAAkB,EAAE;;AAErE,mEAAmE;;AAEnE;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,mEAAmE;;AAEnE;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,mEAAmE;;AAEnE;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;AACrB;;AAEA,YAAY,gBAAgB,EAAE;AAC9B,YAAY,iBAAiB,EAAE;;AAE/B,mEAAmE;;AAEnE;EACE,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,mEAAmE;;AAEnE;EACE,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;EAC7B,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA,mEAAmE;;AAEnE,+DAA+D;AAC/D;EACE,6BAA6B;AAC/B;AACA;;;EAGE,gBAAgB;AAClB;;AAEA,+CAA+C;AAC/C;EACE,gCAAgC;AAClC;;AAEA,mDAAmD;AACnD,WAAW,mBAAmB,EAAE;;AAEhC,0CAA0C;AAC1C;EACE,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;AACvC;;AAEA,mEAAmE;;AAEnE;EACE,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA,+BAA+B;AAC/B;EACE,+BAA+B;EAC/B,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;AACpB;AACA,aAAa,mCAAmC,EAAE,cAAc,EAAE;AAClE,aAAa,mCAAmC,EAAE,cAAc,EAAE;AAClE,kBAAkB,mCAAmC,EAAE,cAAc,EAAE,YAAY,EAAE;AACrF,mBAAmB,YAAY,EAAE;AACjC,8BAA8B,oCAAoC,EAAE,cAAc,EAAE;AACpF,8BAA8B,oCAAoC,EAAE,cAAc,EAAE;AACpF,8BAA8B,qCAAqC,EAAE,cAAc,EAAE;;AAErF,0DAA0D;AAC1D;;0BAE0B,aAAa,EAAE;;AAEzC,0CAA0C;AAC1C;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,qCAAqC;EACrC,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;AAClB;;AAEA,oCAAoC;AACpC;EACE,iBAAiB;EACjB,kCAAkC;EAClC,mBAAmB;EACnB,cAAc;AAChB;;AAEA,YAAY,cAAc,EAAE;;AAE5B,gBAAgB;AAChB;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB,WAAW,gBAAgB,EAAE;AAC7B,YAAY,cAAc,EAAE;AAC5B,YAAY,cAAc,EAAE;;AAE5B,iBAAiB;AACjB,YAAY,iBAAiB,EAAE;;AAE/B;EACE,qBAAqB;EACrB,oCAAoC;EACpC,cAAc;EACd,yCAAyC;EACzC,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA,mEAAmE;;AAEnE;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;AACA,YAAY,oCAAoC,EAAE,cAAc,EAAE;AAClE,YAAY,mCAAmC,EAAE,cAAc,EAAE;AACjE,YAAY,qCAAqC,EAAE,cAAc,EAAE;;AAEnE;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,oBAAoB;AACpB;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;AACd;AACA,sBAAsB,qBAAqB,EAAE,cAAc,EAAE;;AAE7D,+BAA+B;AAC/B;EACE,sBAAsB;EACtB,kBAAkB;EAClB,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,qBAAqB;AACvB;AACA;YACY,qBAAqB,EAAE,cAAc,EAAE;;AAEnD;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,4BAA4B;AAC9B;AACA,iBAAiB,mBAAmB,EAAE;;AAEtC,mEAAmE;;AAEnE;EACE,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA,uBAAuB,cAAc,EAAE;;AAEvC,YAAY,iBAAiB,EAAE;AAC/B,YAAY,qBAAqB,EAAE,iBAAiB,EAAE;;AAEtD;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;AACA,gBAAgB,cAAc,EAAE,gBAAgB,EAAE;AAClD,gBAAgB,yBAAyB,EAAE;AAC3C,gBAAgB,yBAAyB,EAAE;AAC3C,gBAAgB,yBAAyB,EAAE;;AAE3C,oEAAoE;;AAEpE;EACE,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA,WAAW,mBAAmB,EAAE;AAChC,WAAW,mBAAmB,EAAE;AAChC,WAAW,mBAAmB,EAAE;;AAEhC;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA,mEAAmE;;AAEnE;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yCAAyC;EACzC,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;AACA,aAAa,cAAc,EAAE;;AAE7B;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,qBAAqB;AACvB;AACA,aAAa,kBAAkB,EAAE,cAAc,EAAE,kBAAkB,EAAE;AACrE,aAAa,cAAc,EAAE;AAC7B,aAAa,cAAc,EAAE;AAC7B,aAAa,cAAc,EAAE;;AAE7B,mEAAmE;;AAEnE;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,UAAU;EACV,cAAc;AAChB;AACA,qBAAqB,cAAc,EAAE;;AAErC;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,eAAe,gBAAgB,EAAE,cAAc,EAAE,kBAAkB,EAAE;AACrE,YAAY,gBAAgB,EAAE,cAAc,EAAE,qCAAqC,EAAE;;AAErF,cAAc,aAAa,EAAE,sBAAsB,EAAE,WAAW,EAAE;AAClE,oBAAoB,kBAAkB,EAAE,cAAc,EAAE;AACxD;;EAEE,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,aAAa;AACf;AACA;0BAC0B,qBAAqB,EAAE;;AAEjD;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA,mEAAmE;;AAEnE;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA,oBAAoB;AACpB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qCAAqC;EACrC,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,YAAY,cAAc,EAAE;AAC5B,YAAY,cAAc,EAAE,iBAAiB,EAAE;AAC/C,YAAY,cAAc,EAAE,gBAAgB,EAAE;;AAE9C,sBAAsB;AACtB;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA,mEAAmE;;AAEnE,qCAAqC,8BAA8B,EAAE;AACrE,sCAAsC,8BAA8B,EAAE;AACtE,sCAAsC,8BAA8B,EAAE;;AAEtE,kEAAkE;;AAElE;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;AACA,aAAa,cAAc,EAAE;AAC7B,aAAa,cAAc,EAAE;AAC7B,aAAa,cAAc,EAAE;;AAE7B,mEAAmE;;AAEnE;;EAEE,2DAA2D;EAC3D,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,mEAAmE;;AAEnE;EACE,qCAAqC;EACrC,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,2CAA2C;EAC3C,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,mEAAmE;;AAEnE;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,2CAA2C;EAC3C,sBAAsB;AACxB;AACA,yBAAyB,qBAAqB,EAAE,cAAc,EAAE;;AAEhE,mEAAmE;;AAEnE;EACE,cAAc,0BAA0B,EAAE;EAC1C,kBAAkB,0BAA0B,EAAE;AAChD;;AAEA,mEAAmE;;AAEnE;EACE,mCAAmC;EACnC,UAAU,sBAAsB,EAAE,oBAAoB,EAAE,WAAW,EAAE;EACrE,gBAAgB,eAAe,EAAE,WAAW,EAAE;EAC9C,UAAU,uBAAuB,EAAE,kBAAkB,EAAE;EACvD,SAAS,uBAAuB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;EACxE,cAAc,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE;EAC7D,YAAY,kBAAkB,EAAE;;EAEhC,iDAAiD;EACjD,gBAAgB,gBAAgB,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,WAAW,EAAE;EACxF,mBAAmB,uBAAuB,EAAE;EAC5C,mBAAmB,uBAAuB,EAAE,iBAAiB,EAAE;;EAE/D,mBAAmB;EACnB,UAAU,uBAAuB,EAAE,kBAAkB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;EAC7F,WAAW,iBAAiB,EAAE,wBAAwB,EAAE;EACxD,cAAc,MAAM,EAAE,aAAa,EAAE,uBAAuB,EAAE;;EAE9D,+CAA+C;EAC/C,cAAc,gBAAgB,EAAE,gBAAgB,EAAE;EAClD;IACE,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;IACf,qBAAqB;EACvB;EACA,gBAAgB,gBAAgB,EAAE;EAClC,UAAU,aAAa,EAAE;;EAEzB,kCAAkC;EAClC,WAAW,aAAa,EAAE;EAC1B,YAAY,kBAAkB,EAAE;;EAEhC,mBAAmB;EACnB,cAAc,uBAAuB,EAAE,kBAAkB,EAAE;;EAE3D,mCAAmC;EACnC,eAAe,aAAa,EAAE;;EAE9B,qBAAqB;EACrB,UAAU,uBAAuB,EAAE;EACnC,wBAAwB,kBAAkB,EAAE,gBAAgB,EAAE;;EAE9D,2BAA2B;EAC3B,WAAW,kBAAkB,EAAE;EAC/B,WAAW,kBAAkB,EAAE;EAC/B,YAAY,aAAa,EAAE;;EAE3B,mBAAmB;EACnB,kBAAkB,gBAAgB,EAAE,YAAY,EAAE;EAClD,eAAe,wBAAwB,EAAE;EACzC,oBAAoB,kBAAkB,EAAE;EACxC,gBAAgB,kBAAkB,EAAE,wBAAwB,EAAE;;EAE9D,mBAAmB;EACnB,wBAAwB,kBAAkB,EAAE,uBAAuB,EAAE;;EAErE,eAAe;EACf,YAAY,kBAAkB,EAAE;EAChC,YAAY,kBAAkB,EAAE;EAChC,iBAAiB,qBAAqB,EAAE;AAC1C","sourcesContent":[".upcoming-fights {\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n  animation: fadeIn 0.2s ease-in;\n}\n\n/* ── Prop column separator ───────────────────────────────────── */\n.th-prop-sep,\n.td-prop-sep {\n  border-left: 1px solid #1e293b;\n}\n\n/* ── Victory bet column ──────────────────────────────────────── */\n.td-vbet {\n  text-align: right;\n  vertical-align: middle;\n}\n\n/* ── Method bet suggestion (analysis panel) ──────────────────── */\n.ap-method-title {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  font-size: 0.7rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--text-muted, #6b7280);\n  margin-bottom: 0.75rem;\n}\n.ap-method-bet {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  flex-wrap: wrap;\n  font-weight: 400;\n  text-transform: none;\n  letter-spacing: 0;\n  padding: 0.18rem 0.45rem;\n  background: rgba(16, 185, 129, 0.08);\n  border: 1px solid rgba(16, 185, 129, 0.25);\n  border-radius: 4px;\n}\n.amb-label { color: #10b981; font-weight: 600; font-size: 0.65rem; }\n.amb-line  { color: #e2e8f0; font-weight: 600; font-size: 0.72rem; }\n.amb-odds  { color: #94a3b8; font-size: 0.7rem; }\n.amb-bk    { color: #64748b; font-size: 0.65rem; }\n.amb-edge  { color: #10b981; font-weight: 700; font-size: 0.7rem; }\n.amb-kelly { color: #f59e0b; font-weight: 700; font-size: 0.7rem; }\n\n/* ── Model warning banner ─────────────────────────────────────── */\n\n.model-warning-banner {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.6rem;\n  background: rgba(239, 68, 68, 0.08);\n  border: 1px solid rgba(239, 68, 68, 0.3);\n  border-radius: 8px;\n  padding: 0.65rem 1rem;\n  font-size: 0.8rem;\n  color: #fca5a5;\n  line-height: 1.5;\n}\n.mwb-icon {\n  font-size: 0.9rem;\n  flex-shrink: 0;\n  margin-top: 1px;\n}\n.mwb-text { color: #fca5a5; }\n.mwb-text strong { color: #ef4444; }\n.mwb-fight { white-space: nowrap; }\n.mwb-fight em { font-style: normal; color: #94a3b8; font-size: 0.75rem; }\n\n/* ── Filter bar ──────────────────────────────────────────────── */\n\n.uf-bar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.uf-bar-left {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.uf-back {\n  color: #64748b;\n  text-decoration: none;\n  font-size: 0.825rem;\n  font-weight: 500;\n  transition: color 0.15s;\n}\n.uf-back:hover { color: #f59e0b; }\n\n.uf-count {\n  font-size: 0.825rem;\n  color: #64748b;\n}\n\n.uf-count-val {\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: #10b981;\n  background: rgba(16, 185, 129, 0.1);\n  padding: 0.15rem 0.5rem;\n  border-radius: 4px;\n}\n\n.uf-bar-right {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n}\n\n.uf-toggle {\n  display: flex;\n  background: #1e293b;\n  border: 1px solid #334155;\n  border-radius: 6px;\n  overflow: hidden;\n}\n\n.uf-tog {\n  padding: 0.35rem 0.85rem;\n  font-size: 0.78rem;\n  font-weight: 600;\n  background: transparent;\n  border: none;\n  color: #64748b;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n.uf-tog:hover { color: #cbd5e1; }\n.uf-tog-on { background: #334155; color: #f1f5f9; }\n\n.uf-wc {\n  padding: 0.35rem 0.65rem;\n  background: #1e293b;\n  border: 1px solid #334155;\n  border-radius: 6px;\n  color: #cbd5e1;\n  font-size: 0.78rem;\n  cursor: pointer;\n  outline: none;\n}\n\n.uf-refresh {\n  width: 30px;\n  height: 30px;\n  background: #1e293b;\n  border: 1px solid #334155;\n  border-radius: 6px;\n  color: #64748b;\n  font-size: 0.95rem;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.15s;\n}\n.uf-refresh:hover { color: #f59e0b; }\n\n/* ── Single event hero ───────────────────────────────────────── */\n\n.uf-event-hero {\n  background: linear-gradient(135deg, #1e293b 0%, #1a2a3a 100%);\n  border: 1px solid #334155;\n  border-left: 4px solid #f59e0b;\n  border-radius: 10px;\n  padding: 1rem 1.5rem;\n}\n.ueh-name { font-size: 1.25rem; font-weight: 700; color: #f1f5f9; }\n.ueh-meta { font-size: 0.825rem; color: #94a3b8; margin-top: 0.2rem; }\n\n/* ── Empty state ─────────────────────────────────────────────── */\n\n.uf-empty {\n  text-align: center;\n  padding: 3rem;\n  color: #475569;\n  font-size: 0.875rem;\n  background: #1e293b;\n  border: 1px dashed #334155;\n  border-radius: 10px;\n}\n\n/* ── Table container ─────────────────────────────────────────── */\n\n.fights-wrap {\n  background: #1e293b;\n  border: 1px solid #334155;\n  border-radius: 12px;\n  overflow: hidden;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.fights-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.84rem;\n}\n\n/* ── Header row ──────────────────────────────────────────────── */\n\n.fights-table thead tr {\n  background: #0f172a;\n  border-bottom: 1px solid #334155;\n}\n\n.fights-table th {\n  padding: 0.55rem 0.75rem;\n  font-size: 0.68rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.07em;\n  color: #475569;\n  white-space: nowrap;\n}\n\n.th-left  { text-align: left; }\n.th-right { text-align: right; }\n\n/* ── Event group header row ──────────────────────────────────── */\n\n.tr-group td {\n  padding: 0.5rem 0.75rem;\n  background: #0f172a;\n  border-top: 1px solid #334155;\n  border-bottom: 1px solid #1e293b;\n}\n\n.eg-name {\n  font-size: 0.8rem;\n  font-weight: 700;\n  color: #cbd5e1;\n  margin-right: 0.6rem;\n}\n\n.eg-meta {\n  font-size: 0.75rem;\n  color: #475569;\n  margin-right: 0.6rem;\n}\n\n.eg-count {\n  font-size: 0.7rem;\n  color: #334155;\n}\n\n/* ── Card section header row (Main Card / Prelims) ───────────── */\n\n.tr-section td {\n  padding: 0.3rem 0.75rem;\n  background: #1e293b;\n  border-top: 1px solid #334155;\n  border-bottom: 1px solid #334155;\n  font-size: 0.7rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #64748b;\n}\n\n/* ── Fight rows ──────────────────────────────────────────────── */\n\n/* Top of each fight pair — creates visual gap between fights */\n.tr-a td {\n  border-top: 2px solid #0f172a;\n}\n.tr-a:first-child td,\n.tr-group + .tr-a td,\n.tr-section + .tr-a td {\n  border-top: none;\n}\n\n/* Bottom of a fight pair (no analysis below) */\n.tr-last td {\n  border-bottom: 1px solid #1e293b;\n}\n\n/* No bottom border between A and B of same fight */\n.tr-b td { border-bottom: none; }\n\n/* Value-bet row: subtle green highlight */\n.tr-bet {\n  background: rgba(16, 185, 129, 0.04);\n}\n\n.fights-table tbody tr:hover td {\n  background: rgba(255, 255, 255, 0.02);\n}\n\n/* ── Cell styles ─────────────────────────────────────────────── */\n\n.fights-table td {\n  padding: 0.45rem 0.75rem;\n  vertical-align: middle;\n}\n\n/* Context column (rowspan=2) */\n.td-ctx {\n  background: rgba(0, 0, 0, 0.18);\n  vertical-align: middle;\n  border-right: 1px solid #0f172a;\n}\n\n.ctx-wc {\n  font-size: 0.72rem;\n  font-weight: 600;\n  color: #94a3b8;\n  line-height: 1.3;\n}\n\n.ctx-badges {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.25rem;\n  margin-top: 0.2rem;\n}\n\n.ctx-tag {\n  font-size: 0.6rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  padding: 0.1rem 0.35rem;\n  border-radius: 2px;\n}\n.ctx-main  { background: rgba(59, 130, 246, 0.2); color: #93c5fd; }\n.ctx-title { background: rgba(245, 158, 11, 0.2); color: #fbbf24; }\n.ctx-model-warn { background: rgba(239, 68, 68, 0.15); color: #fca5a5; cursor: help; }\n.ctx-reliability { cursor: help; }\n.ctx-reliability.rel-high   { background: rgba(52, 211, 153, 0.15); color: #34d399; }\n.ctx-reliability.rel-medium { background: rgba(251, 191, 36, 0.15); color: #fbbf24; }\n.ctx-reliability.rel-low    { background: rgba(248, 113, 113, 0.15); color: #f87171; }\n\n/* Dim edge/Kelly values for low-reliability predictions */\n.tr-low-rel .td-edge,\n.tr-low-rel .td-kelly,\n.tr-low-rel .kelly-chip { opacity: 0.45; }\n\n/* Reliability warning in analysis panel */\n.ap-reliability-warn {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.5rem;\n  background: rgba(248, 113, 113, 0.08);\n  border: 1px solid rgba(248, 113, 113, 0.2);\n  border-radius: 6px;\n  padding: 0.6rem 0.8rem;\n  margin-bottom: 0.75rem;\n}\n.ap-rel-icon {\n  flex-shrink: 0;\n  width: 1.2rem;\n  height: 1.2rem;\n  line-height: 1.2rem;\n  text-align: center;\n  font-size: 0.7rem;\n  font-weight: 800;\n  background: rgba(248, 113, 113, 0.25);\n  color: #f87171;\n  border-radius: 50%;\n}\n.ap-rel-title {\n  font-size: 0.72rem;\n  font-weight: 700;\n  color: #f87171;\n  margin-bottom: 0.15rem;\n}\n.ap-rel-reason {\n  font-size: 0.68rem;\n  color: #94a3b8;\n  line-height: 1.3;\n}\n\n.ctx-age {\n  font-size: 0.63rem;\n  color: #334155;\n  margin-top: 0.3rem;\n}\n\n/* Fighter name column */\n.td-fighter {\n  min-width: 130px;\n}\n\n/* Numeric columns — right-aligned */\n.td-num {\n  text-align: right;\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n  color: #cbd5e1;\n}\n\n.td-muted { color: #64748b; }\n\n/* Odds column */\n.td-odds {\n  text-align: right;\n  white-space: nowrap;\n}\n\n.odds-val {\n  font-weight: 700;\n  color: #e2e8f0;\n  font-family: 'Courier New', monospace;\n  font-size: 0.88rem;\n}\n\n.odds-bk {\n  display: block;\n  font-size: 0.65rem;\n  color: #475569;\n  margin-top: 0.1rem;\n}\n\n/* Edge column */\n.td-edge { font-weight: 600; }\n.edge-pos { color: #10b981; }\n.edge-neg { color: #475569; }\n\n/* Kelly column */\n.td-kelly { text-align: right; }\n\n.kelly-chip {\n  display: inline-block;\n  background: rgba(16, 185, 129, 0.15);\n  color: #10b981;\n  border: 1px solid rgba(16, 185, 129, 0.3);\n  padding: 0.2rem 0.55rem;\n  border-radius: 4px;\n  font-size: 0.78rem;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.td-dash {\n  color: #334155;\n}\n\n/* ── Past-event result chips ─────────────────────────────────── */\n\n.fighter-cell {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n}\n\n.ctx-method {\n  font-size: 0.7rem;\n  color: #64748b;\n  margin-top: 0.2rem;\n}\n\n.result-chip {\n  display: inline-block;\n  padding: 0.15rem 0.45rem;\n  border-radius: 4px;\n  font-size: 0.75rem;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n}\n.result-w { background: rgba(16, 185, 129, 0.15); color: #10b981; }\n.result-l { background: rgba(239, 68, 68, 0.12); color: #ef4444; }\n.result-d { background: rgba(100, 116, 139, 0.12); color: #94a3b8; }\n\n.td-method {\n  text-align: right;\n  font-size: 0.78rem;\n  color: #94a3b8;\n  white-space: nowrap;\n  vertical-align: middle;\n}\n\n/* Add odds button */\n.add-odds-btn {\n  background: transparent;\n  border: 1px dashed #334155;\n  border-radius: 3px;\n  color: #475569;\n  font-size: 0.72rem;\n  padding: 0.2rem 0.45rem;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: all 0.15s;\n  float: right;\n}\n.add-odds-btn:hover { border-color: #f59e0b; color: #f59e0b; }\n\n/* Actions column (rowspan=2) */\n.td-act {\n  vertical-align: middle;\n  text-align: center;\n  border-left: 1px solid #0f172a;\n  background: rgba(0, 0, 0, 0.1);\n}\n\n.act-expand {\n  display: block;\n  width: 100%;\n  background: none;\n  border: 1px solid #334155;\n  border-radius: 4px;\n  color: #64748b;\n  font-size: 0.7rem;\n  padding: 0.2rem;\n  cursor: pointer;\n  margin-bottom: 0.35rem;\n  transition: all 0.15s;\n}\n.act-expand:hover,\n.act-open { border-color: #f59e0b; color: #f59e0b; }\n\n.act-log {\n  display: block;\n  width: 100%;\n  background: #10b981;\n  color: #0f172a;\n  border: none;\n  border-radius: 4px;\n  font-size: 0.72rem;\n  font-weight: 700;\n  padding: 0.2rem;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n.act-log:hover { background: #34d399; }\n\n/* ── Analysis row ────────────────────────────────────────────── */\n\n.tr-analysis td {\n  padding: 0;\n  border-bottom: 1px solid #334155;\n}\n\n.analysis-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  padding: 1rem 1.25rem;\n  background: #0f172a;\n}\n\n.ap-reasoning {\n  padding: 0.875rem 1rem;\n  background: #1e293b;\n  border-left: 3px solid #f59e0b;\n  border-radius: 4px;\n  font-size: 0.82rem;\n  color: #cbd5e1;\n  line-height: 1.65;\n}\n\n.ap-reasoning strong { color: #f59e0b; }\n\n.r-line   { margin: 0.25rem 0; }\n.r-bullet { padding-left: 0.75rem; margin: 0.15rem 0; }\n\n.ap-no-reason {\n  color: #475569;\n  font-size: 0.82rem;\n  font-style: italic;\n  margin: 0;\n}\n\n.ap-compare {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1rem;\n}\n\n.apc-col {\n  background: #1e293b;\n  border: 1px solid #334155;\n  border-radius: 8px;\n  padding: 0.75rem;\n}\n\n.apc-name {\n  font-size: 0.875rem;\n  font-weight: 700;\n  color: #f1f5f9;\n  padding-bottom: 0.45rem;\n  margin-bottom: 0.45rem;\n  border-bottom: 1px solid #334155;\n}\n\n.apc-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 0.78rem;\n  padding: 0.2rem 0;\n  color: #64748b;\n}\n.apc-row b    { color: #e2e8f0; font-weight: 600; }\n.apc-pos      { color: #10b981 !important; }\n.apc-neg      { color: #475569 !important; }\n.apc-kelly    { color: #f59e0b !important; }\n\n/* ── Method of Victory bars ───────────────────────────────────── */\n\n.ap-method, .ap-glicko2 {\n  margin-top: 0.75rem;\n  padding-top: 0.75rem;\n  border-top: 1px solid #1e293b;\n}\n\n.ap-method-title {\n  font-size: 0.7rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #64748b;\n  margin-bottom: 0.5rem;\n}\n\n.ap-method-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1rem;\n}\n\n.apm-col {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.apm-bar-row {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n}\n\n.apm-label {\n  font-size: 0.7rem;\n  color: #94a3b8;\n  width: 5.5rem;\n  flex-shrink: 0;\n}\n\n.apm-bar {\n  flex: 1;\n  height: 8px;\n  background: #1e293b;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.apm-fill {\n  height: 100%;\n  border-radius: 4px;\n  transition: width 0.3s ease;\n}\n\n.apm-ko  { background: #ef4444; }\n.apm-sub { background: #3b82f6; }\n.apm-dec { background: #6b7280; }\n\n.apm-pct {\n  font-size: 0.75rem;\n  color: #e2e8f0;\n  width: 2.5rem;\n  text-align: right;\n  flex-shrink: 0;\n}\n\n.apm-no-data {\n  font-size: 0.75rem;\n  color: #475569;\n  font-style: italic;\n}\n\n/* ── FighterName tooltip ─────────────────────────────────────── */\n\n.fn-wrap {\n  position: relative;\n  display: inline-block;\n}\n\n.fn-name {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: #e2e8f0;\n  cursor: default;\n  border-bottom: 1px dotted #334155;\n  white-space: nowrap;\n}\n\n.fn-tip {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  z-index: 200;\n  background: #0f172a;\n  border: 1px solid #334155;\n  border-radius: 8px;\n  padding: 0.7rem;\n  min-width: 185px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.6);\n  white-space: nowrap;\n  pointer-events: none;\n}\n\n.fnt-head {\n  font-size: 0.825rem;\n  font-weight: 700;\n  color: #f1f5f9;\n  border-bottom: 1px solid #1e293b;\n  padding-bottom: 0.3rem;\n  margin-bottom: 0.35rem;\n}\n\n.fnt-record {\n  font-size: 0.8rem;\n  font-weight: 700;\n  color: #f59e0b;\n  margin-bottom: 0.35rem;\n}\n\n.fnt-row {\n  display: flex;\n  justify-content: space-between;\n  gap: 1rem;\n  font-size: 0.75rem;\n  color: #64748b;\n  padding: 0.08rem 0;\n}\n.fnt-row b { color: #e2e8f0; }\n\n.fnt-fights {\n  margin-top: 0.4rem;\n  border-top: 1px solid #1e293b;\n  padding-top: 0.35rem;\n}\n.fnt-fights-label {\n  font-size: 0.65rem;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: #334155;\n  margin-bottom: 0.2rem;\n}\n.fnt-fight { font-size: 0.75rem; color: #64748b; padding: 0.06rem 0; }\n.fnt-win   { color: #10b981; }\n.fnt-loss  { color: #ef4444; }\n.fnt-draw  { color: #f59e0b; }\n\n/* ── Modal ───────────────────────────────────────────────────── */\n\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.modal-box {\n  background: #1e293b;\n  border: 1px solid #334155;\n  border-radius: 12px;\n  width: 360px;\n  max-width: 95vw;\n  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.5);\n}\n\n.modal-head {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.875rem 1.25rem;\n  border-bottom: 1px solid #334155;\n  font-weight: 700;\n  color: #f1f5f9;\n  font-size: 0.9rem;\n}\n\n.modal-close {\n  background: none;\n  border: none;\n  color: #64748b;\n  font-size: 1.3rem;\n  cursor: pointer;\n  padding: 0;\n  line-height: 1;\n}\n.modal-close:hover { color: #f1f5f9; }\n\n.modal-body {\n  padding: 1.25rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.875rem;\n}\n\n.modal-bet-summary {\n  display: flex;\n  align-items: baseline;\n  gap: 0.75rem;\n  padding: 0.65rem 0.875rem;\n  background: #0f172a;\n  border-radius: 6px;\n}\n\n.mbs-fighter { font-weight: 700; color: #f1f5f9; font-size: 0.95rem; }\n.mbs-odds { font-weight: 700; color: #f59e0b; font-family: 'Courier New', monospace; }\n\n.form-group { display: flex; flex-direction: column; gap: 0.3rem; }\n.form-group label { font-size: 0.75rem; color: #64748b; }\n.form-group select,\n.form-group input {\n  padding: 0.5rem 0.65rem;\n  background: #0f172a;\n  border: 1px solid #334155;\n  border-radius: 6px;\n  color: #f1f5f9;\n  font-size: 0.875rem;\n  outline: none;\n}\n.form-group select:focus,\n.form-group input:focus { border-color: #f59e0b; }\n\n.modal-foot {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.65rem;\n  padding: 0.875rem 1.25rem;\n  border-top: 1px solid #334155;\n}\n\n/* ── Line Movement ───────────────────────────────────────────── */\n\n.ap-line-movement {\n  margin-top: 1rem;\n  padding-top: 1rem;\n  border-top: 1px solid #1e293b;\n}\n\n/* direction label */\n.lm-direction {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  font-size: 0.82rem;\n  font-weight: 600;\n  padding: 0.15rem 0.5rem;\n  border-radius: 4px;\n  margin-bottom: 0.35rem;\n}\n\n.lm-shortened {\n  color: #4ade80;\n  background: rgba(74, 222, 128, 0.1);\n}\n\n.lm-drifted {\n  color: #fb923c;\n  background: rgba(251, 146, 60, 0.1);\n}\n\n.lm-stable {\n  color: #94a3b8;\n  background: rgba(148, 163, 184, 0.08);\n}\n\n.lm-pct {\n  font-size: 0.75rem;\n  font-weight: 400;\n  opacity: 0.8;\n}\n\n/* opening → current odds row */\n.lm-odds-flow {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  font-family: 'Courier New', monospace;\n  font-size: 0.82rem;\n  margin-bottom: 0.2rem;\n}\n\n.lm-open  { color: #64748b; }\n.lm-arr   { color: #475569; font-size: 0.7rem; }\n.lm-curr  { color: #e2e8f0; font-weight: 600; }\n\n/* snapshot metadata */\n.lm-info {\n  font-size: 0.72rem;\n  color: #475569;\n  font-style: italic;\n}\n\n.lm-tracking {\n  font-size: 0.78rem;\n  color: #475569;\n  font-style: italic;\n}\n\n/* ── Row edge accent borders ─────────────────────────────────── */\n\n.tr-a.row-edge-gold td:first-child { border-left: 3px solid #f59e0b; }\n.tr-a.row-edge-green td:first-child { border-left: 3px solid #10b981; }\n.tr-a.row-edge-blue  td:first-child { border-left: 3px solid #3b82f6; }\n\n/* ── Signal labels in edge column ───────────────────────────── */\n\n.edge-signal {\n  display: block;\n  font-size: 0.6rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  margin-bottom: 2px;\n  line-height: 1;\n}\n.sig-gold  { color: #f59e0b; }\n.sig-green { color: #10b981; }\n.sig-blue  { color: #3b82f6; }\n\n/* ── Fighter name font ───────────────────────────────────────── */\n\n.fighter-cell,\n.fn-name {\n  font-family: 'Barlow Condensed', 'Arial Narrow', sans-serif;\n  font-weight: 700;\n  font-size: 0.97rem;\n  letter-spacing: 0.02em;\n}\n\n/* ── Analysis panel: Bet hero ────────────────────────────────── */\n\n.ap-bet-hero {\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid #334155;\n  border-radius: 6px;\n  padding: 0.75rem 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.ap-bet-hero-pick {\n  font-size: 0.72rem;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: #64748b;\n}\n\n.ap-bet-hero-name {\n  font-family: 'Barlow Condensed', sans-serif;\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: #f1f5f9;\n}\n\n.ap-hero-signal {\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n}\n\n.ap-bet-hero-detail {\n  font-size: 0.8rem;\n  color: #94a3b8;\n}\n\n/* ── Analysis panel: Extra context toggle ────────────────────── */\n\n.ap-extra-toggle {\n  background: none;\n  border: 1px solid #334155;\n  border-radius: 4px;\n  color: #64748b;\n  font-size: 0.75rem;\n  cursor: pointer;\n  padding: 0.3rem 0.75rem;\n  transition: border-color 0.15s, color 0.15s;\n  align-self: flex-start;\n}\n.ap-extra-toggle:hover { border-color: #475569; color: #94a3b8; }\n\n/* ── Tablet ──────────────────────────────────────────────────── */\n\n@media (max-width: 900px) {\n  .ap-compare { grid-template-columns: 1fr; }\n  .ap-method-grid { grid-template-columns: 1fr; }\n}\n\n/* ── Mobile ──────────────────────────────────────────────────── */\n\n@media (max-width: 600px) {\n  /* Filter bar: compact horizontal */\n  .uf-bar { flex-direction: column; align-items: stretch; gap: 0.4rem; }\n  .uf-bar-right { flex-wrap: wrap; gap: 0.4rem; }\n  .uf-tog { padding: 0.3rem 0.55rem; font-size: 0.72rem; }\n  .uf-wc { padding: 0.3rem 0.45rem; font-size: 0.72rem; max-width: 120px; }\n  .uf-refresh { width: 28px; height: 28px; font-size: 0.85rem; }\n  .uf-count { font-size: 0.75rem; }\n\n  /* Table: fixed layout, percentages sum to 100% */\n  .fights-table { min-width: unset; font-size: 0.76rem; table-layout: fixed; width: 100%; }\n  .fights-table td { padding: 0.35rem 0.4rem; }\n  .fights-table th { padding: 0.4rem 0.35rem; font-size: 0.6rem; }\n\n  /* Context column */\n  .td-ctx { padding: 0.1rem 0.05rem; text-align: center; border-right: none; overflow: hidden; }\n  .ctx-tag { font-size: 0.5rem; padding: 0.02rem 0.08rem; }\n  .ctx-badges { gap: 0; margin-top: 0; justify-content: center; }\n\n  /* Fighter name: truncate within fixed column */\n  .td-fighter { min-width: unset; overflow: hidden; }\n  .fn-name {\n    font-size: 0.72rem;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 100%;\n    display: inline-block;\n  }\n  .fighter-cell { overflow: hidden; }\n  .fn-tip { display: none; }\n\n  /* Odds: hide bookmaker, compact */\n  .odds-bk { display: none; }\n  .odds-val { font-size: 0.72rem; }\n\n  /* Kelly: compact */\n  .kelly-chip { padding: 0.1rem 0.25rem; font-size: 0.65rem; }\n\n  /* Edge signals: hidden on mobile */\n  .edge-signal { display: none; }\n\n  /* Actions: tighter */\n  .td-act { padding: 0.25rem 0.3rem; }\n  .act-expand, .act-log { font-size: 0.65rem; padding: 0.15rem; }\n\n  /* Event headers: compact */\n  .eg-name { font-size: 0.72rem; }\n  .eg-meta { font-size: 0.68rem; }\n  .eg-count { display: none; }\n\n  /* Analysis panel */\n  .analysis-panel { padding: 0.75rem; gap: 0.75rem; }\n  .ap-bet-hero { padding: 0.55rem 0.75rem; }\n  .ap-bet-hero-name { font-size: 0.95rem; }\n  .ap-reasoning { font-size: 0.76rem; padding: 0.65rem 0.75rem; }\n\n  /* Warning banner */\n  .model-warning-banner { font-size: 0.72rem; padding: 0.5rem 0.75rem; }\n\n  /* Event hero */\n  .ueh-name { font-size: 1.05rem; }\n  .ueh-meta { font-size: 0.75rem; }\n  .uf-event-hero { padding: 0.75rem 1rem; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
